<div
  class="grid"
  style="margin-top: 8px;"
  *ngIf="(
    (deviceMeasurements && deviceMeasurements.length > 0) ||
    (assetMeasurements && assetMeasurements.length > 0)
  )"
>
  <div class="col-12">
    <div class="flex flex-column sm:flex-row justify-content-between card">
      <div class="flex flex-column xl:flex-row">
        <p-calendar
          [(ngModel)]="rangeDates"
          [firstDayOfWeek]="1"
          [readonlyInput]="false"
          [style]="{'min-width': '180px'}"
          styleClass="w-full"
          selectionMode="range"
          dateFormat="dd/mm/yy"
          inputId="range"
        >
        </p-calendar>
        <p-multiSelect
          [(ngModel)]="selectedAssetMeasurements"
          [placeholder]="'select.assetSensors' | transloco"
          [options]="assetMeasurements"
          [maxSelectedLabels]="1"
          [selectedItemsLabel]="'{0} ' + ('misc.sensorsSelected' | transloco).toLowerCase()"
          [filter]="true"
          (onChange)="loadAssetMeasurementUnits()"
          class="mt-2 xl:mt-0 xl:ml-2"
          styleClass="w-full"
          optionLabel="name"
          optionValue="uuid"
          filterBy="nameDesc"
        ></p-multiSelect>
        <p-multiSelect
          [(ngModel)]="selectedDeviceMeasurements"
          [placeholder]="'select.deviceSensors' | transloco"
          [options]="deviceMeasurementsItemList"
          [maxSelectedLabels]="1"
          [selectedItemsLabel]="'{0} ' + ('misc.sensorsSelected' | transloco).toLowerCase()"
          [filter]="true"
          [group]="true"
          (onChange)="loadDeviceMeasurementUnits()"
          class="mt-2 xl:mt-0 xl:ml-2"
          styleClass="w-full"
          optionLabel="name"
          optionValue="uuid"
          filterBy="nameDesc"
        >
          <ng-template let-group pTemplate="group">
            <div class="p-d-flex p-ai-center">
              <span>{{group.name}}</span>
            </div>
          </ng-template>
        </p-multiSelect>
        <p-button
          [label]="'common.search' | transloco"
          [disabled]="!rangeDates || !rangeDates[1]"
          (onClick)="searchMeasures()"
          class="mt-2 xl:mt-0 xl:ml-2"
          styleClass="w-full"
        ></p-button>
      </div>
      <div class="flex flex-column sm:flex-row justify-content-center p-fluid">
        <button
          *ngIf="'ROLE_ADMIN' | userHasRole"
          [label]="'common.importCsv' | transloco"
          pButton
          class="p-button-secondary md:mr-2"
          routerLink="../measurements/import"
          icon="pi pi-upload"
        ></button>
        <p-selectButton
          [(ngModel)]="selectedModeOption"
          [options]="modeOptions"
          class="mt-2 sm:mt-0"
          styleClass="w-full"
          optionLabel="label"
        ></p-selectButton>
      </div>
    </div>
  </div>
</div>
<div class="grid" style="margin-top: 1px;"
     *ngIf="(
       (deviceMeasurements && deviceMeasurements.length > 0) ||
       (assetMeasurements && assetMeasurements.length > 0)
     )">
  <div class="col-12">
    <div class="card" style="min-height: 570px;">
      <div class="flex flex-column sm:flex-row justify-content-between">
        <h4>{{'model.measures' | transloco}}</h4>
        <div class="flex flex-column sm:flex-row justify-content-center p-fluid">
          <button
            [label]="'common.actions' | transloco"
            (click)="menu.toggle($event)"
            type="button"
            pButton icon="pi pi-bars"
          ></button>
          <p-menu #menu [popup]="true" [model]="actionsMeasure" id="options"></p-menu>
        </div>
      </div>
      <hr>
      <div class="flex">
        <div id="table" *ngIf="displayActionsDialog" style="min-width: 250px;">
          <div class="flex flex-row-reverse">
            <button
              (click)="hideConversions()"
              pButton
              pRipple
              type="button"
              icon="pi pi-times"
              class="p-button-rounded p-button-text"
            ></button>
          </div>
          <div>
            <p-table [value]="groupedAssetMeasurementUnit">
              <ng-template let-item pTemplate="body">
                <div class="col-12">
                  <div class="col-12 form-field">
                    <label>{{item.measure}}</label>
                  </div>
                  <div class="col-12">
                    <p-dropdown
                      [(ngModel)]="selectedAssetMeasurementsUnit[item.measure]"
                      [placeholder]="'select.unit' | transloco"
                      [options]="item.items"
                      [filter]="true"
                      class="mt-2 xl:mt-0 xl:ml-0"
                      optionLabel="target"
                      appendTo="body"
                      [style]="{'min-width': '100px'}"
                      filterBy="target"
                    >
                      <ng-template let-selected pTemplate="selectedItem">{{selected.name}}</ng-template>
                      <ng-template let-possibility pTemplate="item">{{possibility.name}}</ng-template>
                    </p-dropdown>
                  </div>
                </div>
              </ng-template>
            </p-table>
            <p-table [value]="groupedDeviceMeasurementUnit">
              <ng-template let-item pTemplate="body">
                <div class="col-12">
                  <div class="col-12 form-field">
                    <label>{{item.measure}}</label>
                  </div>
                  <div class="col-12">
                    <p-dropdown
                      [(ngModel)]="selectedDeviceMeasurementsUnit[item.measure]"
                      [placeholder]="'select.unit' | transloco"
                      [options]="item.items"
                      [filter]="true"
                      class="mt-2 xl:mt-0 xl:ml-0"
                      optionLabel="target"
                      appendTo="body"
                      [style]="{'min-width': '100px'}"
                      filterBy="target"
                    >
                      <ng-template let-selected pTemplate="selectedItem">{{selected.name}}</ng-template>
                      <ng-template let-possibility pTemplate="item">{{possibility.name}}</ng-template>
                    </p-dropdown>
                  </div>
                </div>
              </ng-template>
            </p-table>
            <div *ngIf="(
            (!groupedAssetMeasurementUnit || groupedAssetMeasurementUnit.length == 0) &&
            (!groupedDeviceMeasurementUnit || groupedDeviceMeasurementUnit.length == 0))">
              <p class="w-full text-xl text-center p-6 font-italic">{{ 'empty.measuresWithUnitSelected' | transloco }}</p>
            </div>
            <div class="col-12" *ngIf="(
            (groupedAssetMeasurementUnit && groupedAssetMeasurementUnit.length > 0) ||
            (groupedDeviceMeasurementUnit && groupedDeviceMeasurementUnit.length > 0))">
              <p-button [label]="'common.restore' | transloco" (onClick)="clearConversions()" styleClass="p-button-danger" type="button"></p-button>
              <p-button [label]="'primeng.apply' | transloco" (onClick)="searchMeasures()" styleClass="p-button-primary mx-2 mt-2" type="button"></p-button>
            </div>
          </div>
        </div>
        <div [style.width]="displayActionsDialog ? 'calc(100% - 250px)' : '100%'">
          <app-generic-graph
            *ngIf="measures && selectedModeOption.value === 'chart'"
            [data]="measures"
            [name]="'attribute.value' | transloco"
            [height]="500"
            [yAxis]="graphAxis"
            [customSeries]="true"
            [legend]="true"
            chartType="line"
            tooltipDecimalPlaces="3"
            tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
            #measuresChart
          ></app-generic-graph>
          <app-table-skeleton
            *ngIf="loadingMeasurements && selectedModeOption.value === 'chart'"
            [rows]="12"
          ></app-table-skeleton>
          <p-table
            *ngIf="tableMeasures && selectedModeOption.value === 'table'"
            [value]="tableMeasures"
            [paginator]="true"
            [(first)]="first"
            [(rows)]="rows"
            [totalRecords]="totalMeasures"
            [sortOrder]="-1"
            sortField="timestamp"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="measurementName">
                  {{'model.measurement' | transloco}} <p-sortIcon field="measurementName"></p-sortIcon></th>
                <th pSortableColumn="timestamp">
                  {{'attribute.timestamp' | transloco}} <p-sortIcon field="timestamp"></p-sortIcon></th>
                <th pSortableColumn="value">
                  {{'attribute.value' | transloco}} <p-sortIcon field="value"></p-sortIcon></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-measure>
              <tr>
                <td>
                  <span class="p-column-title bold">{{'model.measurement' | transloco}}</span>
                  {{measure.measurementName}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.timestamp' | transloco}}</span>
                  {{measure.timestamp | customDate: ({showTimezone: true})}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
                  {{measure.value + ' ' + (measure.unit ?? '')}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures == 0">
                {{'pagination.empty' | transloco}}
              </div>
              <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures > 0">
                {{'pagination.showing' | transloco}} {{first+1}}
                {{'pagination.to' | transloco}} {{(first+rows) >= totalMeasures ? totalMeasures : (first+rows)}}
                {{'pagination.of' | transloco}} {{totalMeasures}}
                {{(totalMeasures > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="flex" style="margin-top: 15px;"
  *ngIf="(
    deviceMeasurements &&
    deviceMeasurements.length == 0 &&
    assetMeasurements &&
    assetMeasurements.length == 0 &&
    !loadingMeasurements
  )"
>
  <div class="card w-full">
    <div class="flex flex-column sm:flex-row justify-content-end">
      <button
        *ngIf="'ROLE_ADMIN' | userHasRole"
        [label]="'common.importCsv' | transloco"
        pButton
        class="p-button-secondary md:mr-2"
        routerLink="../measurements/import"
        icon="pi pi-upload"
      ></button>
    </div>
    <p class="text-xl text-center p-6 font-italic mb-4">{{'empty.measures' | transloco}}</p>
  </div>
</div>
<div *ngIf="(deviceMeasurements &&
    deviceMeasurements.length == 0 &&
    assetMeasurements &&
    assetMeasurements.length == 0 &&
    loadingMeasurements)"
    class="flex"
    style="margin-top: 15px;"
>
  <div class="card w-full">
    <app-table-skeleton [rows]="14" height="500px"></app-table-skeleton>
  </div>
</div>


<app-export-xls *ngIf="exportVisible"
                [content]="tableMeasures"
                [first]="first"
                [typeContent]="'MEASUREMENTS'"
                [(visible)]="exportVisible">
</app-export-xls>
